import { Box, BoxProps } from '@/components/custom-components/Layout/Box'
import { cn } from '@/lib/utils.ts'

type StackProps = BoxProps

export const Stack = ({ className, ...props }: StackProps) => {
  return <Box className={cn('flex flex-col', className)} {...props} />
}
